import React from 'react';
import { isEmpty } from 'ramda';

import MerchantNamePresenter from '../../../../../../../../presenters/MerchantNamePresenter';

const MerchantNamesTable = (props) => {
  const { merchantNames, onDeleteButtonClick } = props;

  if (isEmpty(merchantNames)) {
    return 'The brand has no merchant names';
  }

  return (
    <div className="tags">
      <table className="tables">
        <thead>
          <tr>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {merchantNames.map((merchantName) => (
            <tr key={MerchantNamePresenter.id(merchantName)}>
              <td>{MerchantNamePresenter.name(merchantName)}</td>
              <td className="actions-column">
                <button
                  className="action-button -in-group"
                  onClick={() => onDeleteButtonClick(merchantName)}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MerchantNamesTable;
